<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Detalhes da Pesquisa</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Parametrize o template da pesquisa
      </span>
      <div class="ms-auto my-auto">
        <router-link
          :to="`/params/surveys`"
          class="btn btn-link"
          title="Voltar"
        >
          Voltar
        </router-link>
      </div>
    </div>
    <ul class="nav nav-tabs nav-tabs-highlight nav-justified">
      <li class="nav-item">
        <a
          href="#sv-tab-detail"
          class="nav-link active"
          data-bs-toggle="tab"
          aria-selected="true"
          title="Configurações Gerais"
          role="tab"
          @click="setSelectedTab('details')"
        >
          <div class="d-flex align-items-center">
            <i
              class="ph ph-globe-hemisphere-west ph-lg bg-primary text-primary bg-opacity-10 rounded p-2 me-3"
            />
            <div class="fw-semibold">Configurações Gerais</div>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#sv-tab-list"
          class="nav-link"
          data-bs-toggle="tab"
          aria-selected="true"
          title="Perguntas Cadastradas"
          role="tab"
          @click="setSelectedTab('list')"
        >
          <div class="d-flex align-items-center">
            <i
              class="ph ph-list ph-lg bg-primary text-primary bg-opacity-10 rounded p-2 me-3"
            />
            <div class="fw-semibold">Perguntas Cadastradas</div>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#sv-tab-preview"
          class="nav-link"
          data-bs-toggle="tab"
          aria-selected="true"
          title="Pré-Visualização"
          role="tab"
          @click="setSelectedTab('preview')"
        >
          <div class="d-flex align-items-center">
            <i
              class="ph ph-eye ph-lg bg-primary text-primary bg-opacity-10 rounded p-2 me-3"
            />
            <div class="fw-semibold">Pré-Visualização</div>
          </div>
        </a>
      </li>
    </ul>
    <div class="tab-content mt-2">
      <div id="sv-tab-detail" class="tab-pane fade active show" role="tabpanel">
        <EditSurvey v-if="selectedTab === 'details'" :surveyId="surveyId" />
      </div>
      <div id="sv-tab-list" class="tab-pane fade" role="tabpanel">
        <FormsSurvey v-if="selectedTab === 'list'" :surveyId="surveyId" />
      </div>
      <div id="sv-tab-preview" class="tab-pane fade" role="tabpanel">
        <PreviewSurvey v-if="selectedTab === 'preview'" :surveyId="surveyId" />
      </div>
    </div>
  </div>
</template>

<script>
import EditSurvey from '@/components/params/surveys/EditSurvey.vue'
import FormsSurvey from '@/components/params/surveys/FormsSurvey.vue'
import PreviewSurvey from '@/components/params/surveys/PreviewSurvey.vue'

export default {
  name: 'SurveysDetails',

  components: {
    EditSurvey,
    FormsSurvey,
    PreviewSurvey,
  },

  data() {
    return {
      surveyId: this.$route.params.surveyId,
      selectedTab: 'details',
    }
  },

  methods: {
    setSelectedTab(tab) {
      this.selectedTab = tab
    },
  },
}
</script>
